import styled, { css } from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;

export const PageContent = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  ${({ theme: { spacing } }) => css`
    padding: 0 ${spacing.level6} ${spacing.level6};
  `}

  @media (max-width: 768px) {
    ${({ theme: { spacing } }) => css`
      padding: 0 ${spacing.level4} ${spacing.level5};
    `}
  }
`;

export const PlaceholderText = styled.p`
  ${({ theme: { colors, font } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    color: ${colors.onSurfaceVariant};
  `}
`;
